module.exports = __webpack_public_path__ + "static/media/06-kor.67decfd4.png";